import React from "react";
import { MdDelete } from "react-icons/md";
import Modal from "./Modal";

const DeleteModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirm Delete", 
  message = "Are you sure you want to delete this item? This action cannot be undone.", 
  isDeleting = false,
  confirmText = "Delete",
  cancelText = "Cancel"
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="px-6 py-4">
        <p className="text-sm text-slate-600 mb-6">{message}</p>
        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition inline-flex items-center gap-2"
          >
            <MdDelete className="w-4 h-4" />
            {isDeleting ? "Deleting..." : confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;